'use strict';
/**
 * User Service
 * Provides CRUD operations for application users
 * 1. getAllUsers - get list of users
 * 2. getUser - get single user
 * 3. createUser - create new user
 * 4. updateUser - update existing user
 * 5. deleteUser - delete existing user
 */

const angular = require('angular');

/**
 * Variables
 */

var adminBaseURL; // base url for making requests to admin user API
var currentUser;

/*@ngInject*/
export function userService($http, baseConfigService) {
    adminBaseURL = baseConfigService.getAdminBaseURL();

    // Get list of users
    this.getAllUsers = function () {
        return $http.get(`${adminBaseURL}/users`);
    };

    // Get single user
    this.getUser = function (id) {
        return $http.get(`${adminBaseURL}/users/${id}`);
    };

    // Create new user
    this.createUser = function () {
        return $http.post(`${adminBaseURL}/users`);
    };
    // Update existing user
    this.updateUser = function (id) {
        return $http.post(`${adminBaseURL}/users/${id}`);
    };

    // Delete user
    this.deleteUser = function (id) {
        return $http.delete(`${adminBaseURL}/users/${id}`);
    };

     // Get Current user
     this.getCurrentUser = function () {
        return $http.get(`${adminBaseURL}/users/me/toc_app`)
    };

     // Set Current user
     this.setCurrentUser = function (user) {
        currentUser = user;
    };
}

export default angular.module('appApp.users', [])
.service('userService', userService)
.name;




// WEBPACK FOOTER //
// ./client/components/services/users/users.service.js